export default 'https://wx.shareplay.cc';



// WEBPACK FOOTER //
// ./src/api/baseUrl.js